/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';

export const SvgPostMore = ({ size }) => {
    return (<Svg width={size} height={size} viewBox="0 0 44.48 44.48">
        <Path class="cls-1" fill='#48536e' d="M0,22.24A22.24,22.24,0,1,1,22.25,44.48,22.27,22.27,0,0,1,0,22.24ZM22.25,2.3a19.94,19.94,0,1,0,19.94,20A20,20,0,0,0,22.25,2.3Z" />
        <Circle class="cls-2" fill='none' stroke='#48536e'
            strokeMiterlimit={10}
            strokeWidth={1.7} cx="9.9" cy="22.24" r="4.56" />
        <Circle class="cls-2" fill='none' stroke='#48536e' strokeMiterlimit={10}
            strokeWidth={1.7} cx="22.24" cy="22.24" r="4.56" />
        <Circle class="cls-2" fill='none' stroke='#48536e' strokeMiterlimit={10}
            strokeWidth={1.7} cx="34.58" cy="22.24" r="4.56" />
    </Svg>)
}

